const HttpStatusCode = {

    OK: 200,

    BAD_REQUEST: 400,

    UNAUTHORIZED: 401,

    FORBIDDEN: 403,

    NOT_FOUND: 404,

    INTERNAL_SERVER_ERROR: 500,

    NOT_IMPLEMENTED: 501,

    BAD_GATEWAY: 502,

    SERVICE_UNAVAILABLE: 503,


}
const ResultCodes = {
    USER_NOT_REGISTERED: "30001",
    LAST_SIGNON_ATTEMPT: "30002",
    ACCT_LOCKED: "30003",
    NO_ELIGIBLE_ACCT: "30004",
    RA_DENY: "30005",
    ACCT_ALREADY_LINKED: "30006",
    ACCT_LINKING_PAGE: "30007",
    TOOMANY_OOBS_REQSTED: "30008",
    CARD_MEMBER_LOCKOUT: "30009",
    VALIDATE_OOB_PAGE: "30010",
    CID_PAGE:"30011",
    MERCHANT_REDIRECT_PAGE: "30012",
    INVALID_OOB_CODE:"30013",
    FINAL_OOB_ATTEMPT:"30014",
    EXPIRED_OOB_CODE:"30015",
    CONTACT_SELECTION_PAGE: "30016",
    INVALID_EXP_DATE: "30017",
    CARD_INFO_DELIVERY_FAILED: "30018",
    NO_CONTACT_CHNL: "30019",
    REDIRECT_TO_MERCHANT: "30022",
    MAX_PROVISION_LIMIT: "30021",
    MIGRATIONSTATUS_INPROGRESS: "30112",
    MIGRATIONSTATUS_MIGRATED:"30113",

    

    MANDATORY_FIELD: "800", 
    TECH_DIFF_FI_DOWN: "40001",
    TECH_DIFF_RA_DOWN: "40002",
    TECH_DIFF_DPL_DOWN: "40003",
    TECH_DIFF_CACHE_DOWN: "40004",
    TECH_DIFF_NO_LINK_ACTIVITY: "40005",
    INVALID_EXT_STATUS: "30020"
}
const Messages = {
    INFORM_NOT_MATCH: "The information you provided does not match our records. Please re-enter your login information below.",
    ACCT_LOCKED: "We've placed a lock on your account to prevent unauthorized users from logging in.",
    UNABLE_TO_LINK: "We were unable to link your account. Sorry, something went wrong. ",
    CONFORM_LINK_MSG: "Confirm this is the account you'd like to link with ",
    CONFORM_MULTICARD_MSG: "Select the accounts you'd like to link with ",
    ENTER_VALID_OOB_CODE: "Please enter a valid identification code.",
    INVALID_OOB_CODE: "Invalid code. Please re-enter. If your next attempt is invalid, you will be asked to contact us.",
    EXPIRED__OOB_CODE: "Expired identification code. Please request a new code by clicking the 'Get a New Code' link.",
    ENTER_VALID_CVV_CODE: "Please enter a valid security code.",
    ENTER_VALID_EXPIRY_DATE: "Please enter a valid expiration date.",
    INVALID_EXT_STATUS: "Due to special conditions related to your credit card account, we cannot provide you with access to your account information at this time. Please contact Customer Service so we can help you resolve this issue: 1-800-347-3055",
    MIGRATED_ACCOUNT_STATUS:`Discover is now part of Capital One\nSelect "Cancel" to return to PayPal, then manually enter your credit card details to add it to your PayPal Wallet.`
}

export { HttpStatusCode, ResultCodes, Messages};
